export default {"src":"/_next/static/media/white-phone.184a435f.svg","height":24,"width":24};